import styled, { css } from 'styled-components';
import Table from '@material-ui/core/Table';
import { EEkycStatuses } from 'types/entities/users';

export const CellButtonsStyled = styled.div`
    display: inline-grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 1rem;
    justify-content: flex-start;
    width: 100px;
`;

export const CellButtonContentStyled = styled.span`
    display: grid;
    justify-content: center;
    align-items: center;
    grid-auto-flow: column;
    gap: 0.5rem;
    svg {
        width: 1rem;
    }
`;

export const TableStyled = styled(Table)``;

export const CellEkycStatusProcessing = styled.span`
    display: grid;
    grid-auto-flow: row;
    gap: 0.5rem;
    justify-content: flex-start;
`;

export const Root = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
`;
